module.exports = __webpack_public_path__ + "static/media/IMG-3.5f166d30.jpg";